"use strict";

function toggleBodyClass(classList) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var list = classList.split(' ');
  var body = document.body;
  var bodyClassList = body.classList;

  if (event && list.length) {
    event.stopPropagation();
    list.forEach(function (c) {
      body.classList.toggle(c);
    });
  } else if (list.length) {
    list.forEach(function (c) {
      body.classList.remove(c);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function () {
    toggleBodyClass('has-menu-open has-search-open');
  });
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ActiveSection =
/*#__PURE__*/
function () {
  function ActiveSection(item, params) {
    _classCallCheck(this, ActiveSection);

    this.item = item;
    this.section = document.getElementById(this.item.dataset.target);
    this.progress = this.item.querySelector('.js-active-section-progress');
    this.scrollX = params.scrollX;
    this.scrollY = params.scrollY;
    this.container = params.container;

    if (this.section) {
      this.coords = this.getCoords();
      this.listen();
    }
  }

  _createClass(ActiveSection, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      var listener = this.container ? this.container : window;
      listener.addEventListener('scroll', function (event) {
        _this.coords = _this.getCoords();
        var scroll = _this.container ? listener.scrollTop : listener.scrollY;

        if (scroll >= _this.coords.top && scroll < _this.coords.bottom) {
          _this.item.classList.add('is-active');

          if (_this.scrollX) {
            _this.scrollX.scroll({
              left: _this.item.offsetLeft
            });
          }

          if (_this.scrollY) {
            _this.scrollY.scroll({
              top: _this.item.offsetTop - _this.scrollY.offsetTop
            });
          }
        } else {
          _this.item.classList.remove('is-active');
        }

        _this.setProgression(scroll);
      });
    }
  }, {
    key: "getCoords",
    value: function getCoords() {
      var height = this.section.offsetHeight;
      var top = this.section.offsetTop;
      var offset = this.container ? this.container.offsetTop : 0;
      return {
        height: height,
        top: top - offset,
        bottom: top + height - offset
      };
    }
  }, {
    key: "setProgression",
    value: function setProgression(scroll) {
      if (this.progress) {
        var percent = (scroll - this.coords.top) / this.coords.height * 100;
        this.progress.style.width = percent < 100 ? "".concat(percent, "%") : '0';
      }
    }
  }]);

  return ActiveSection;
}();

document.addEventListener('DOMContentLoaded', function () {
  var sections = _toConsumableArray(document.getElementsByClassName('js-active-section'));

  if (sections.length) {
    sections.forEach(function (section) {
      return new ActiveSection(section, {
        container: document.getElementById(section.dataset.container),
        scrollX: document.getElementById(section.dataset.scrollX),
        scrollY: document.getElementById(section.dataset.scrollY)
      });
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Collapse =
/*#__PURE__*/
function () {
  function Collapse(collapse) {
    _classCallCheck(this, Collapse);

    this.collapse = collapse;
    this.header = collapse.querySelector('.collapse-header');
    this.content = collapse.querySelector('.collapse-content');
    this.wrapper = this.content.querySelector('div');
    this.listen();
  }

  _createClass(Collapse, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.header.addEventListener('click', function () {
        return _this.resize();
      });
      window.addEventListener('resize', function () {
        return _this.resize(false);
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      var collapse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (collapse) {
        this.collapse.classList.toggle('is-open');
      }

      var open = this.collapse.classList.contains('is-open');
      var height = open ? this.wrapper.offsetHeight : 0;
      this.content.style.height = "".concat(height, "px");
    }
  }]);

  return Collapse;
}();

document.addEventListener('DOMContentLoaded', function () {
  var collapse = _toConsumableArray(document.getElementsByClassName('js-collapse'));

  if (collapse.length) {
    collapse.forEach(function (collapse) {
      return new Collapse(collapse);
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Carousel =
/*#__PURE__*/
function () {
  function Carousel(container, slides, params) {
    _classCallCheck(this, Carousel);

    this.container = container;
    this.carousel = container.querySelector('.js-carousel') || this.container;
    this.slider = container.querySelector('.js-carousel-items');
    this.dots = this.container.querySelector('.js-carousel-dots');
    this.legend = document.querySelector('.js-carousel-title');
    this.slides = slides;
    this.length = slides ? slides.length : 0;
    this.posX = 0;
    this.touching = false;
    this.animating = false;
    var defaultParams = {
      type: 'fade',
      hasTimeout: false,
      transition: 1000,
      cssTransition: 1000,
      visibleSlides: 1,
      breakpoints: [{
        breakpoint: 376,
        slides: 1
      }, {
        breakpoint: 769,
        slides: 2
      }],
      hammerEnabled: true,
      hammerBreakpoint: 769,
      steps: 1,
      auto: false,
      delay: 4000,
      infinite: false,
      autoHeigth: false,
      autoDots: false
    };
    this.params = _extends(defaultParams, params);
    console.log(this.params.autoDots);
    this.init();
  } //////////
  // INIT //
  //////////


  _createClass(Carousel, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.currentIndex = 0;
      this.slides = _toConsumableArray(this.slider.children);
      this.length = this.slides.length;

      if (this.params.infinite) {
        // Create Clones
        var first = this.slides[this.length - 1].cloneNode(true);
        var last = this.slides[0].cloneNode(true);
        first.dataset.index = -1;
        last.dataset.index = this.length;
        this.slides.forEach(function (slide, index) {
          slide.dataset.index = index;

          _this.slider.appendChild(slide);
        }); // Insert Clones

        this.slider.insertBefore(first, this.slider.firstChild);
        this.slider.appendChild(last);
        this.slides.unshift(first);
        this.slides.push(last);
      } else {
        this.slides.forEach(function (slide, index) {
          slide.dataset.index = index;

          _this.slider.appendChild(slide);
        });
      }

      this.initSlider();
      this.initDots();
      this.setNeighboursClasses();
      this.bindControls();
      this.bindResize();
      this.bindHover();
      this.bindVisibilityChange();
      this.loop();
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      if (this.params.type !== 'fade') {
        this.setDimensions();
        this.bindHammer();

        if (this.params.infinite) {
          this.next(true, false, false);
        } else if (this.currentIndex !== 0) {
          this.goTo(this.currentIndex, true, false);
        }
      }
    }
  }, {
    key: "initDots",
    value: function initDots() {
      if (this.dots) {
        var dots = _toConsumableArray(this.dots.children);

        dots.forEach(function (dot, index) {
          dot.dataset.index = index;
        });
      } else if (this.params.autoDots) {
        this.dots = document.createElement('ul');
        this.dots.classList.add('js-carousel-dots', 'carousel-dots');
        console.log(this.length);

        for (var i = 0; i < this.length; i += 1) {
          this.dots.innerHTML += "<li class=\"carousel-dot\" data-index=\"".concat(i, "\"></li>");
        }

        this.container.appendChild(this.dots);
      }
    } ///////////////
    // ACTIONS ////
    ///////////////

  }, {
    key: "prev",
    value: function prev() {
      var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var index = this.currentIndex - this.getVisibleSlides(this.params.steps);
      this.goTo(index, translate, transition);
    }
  }, {
    key: "next",
    value: function next() {
      var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var increment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var index = increment ? this.currentIndex + this.getVisibleSlides(this.params.steps) : this.currentIndex;
      this.goTo(index, translate, transition);
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      var translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var transition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.setTransition();

      if (this.params.infinite) {
        if (index >= -1 && index <= this.length) {
          this.currentIndex = index;
        } else if (Math.sign(index) === -1) {
          this.currentIndex = this.length - 1;
        } else if (index > this.length) {
          this.currentIndex = 0;
        }
      } else if (this.params.visibleSlides > 1) {
        var max = this.length - this.params.visibleSlides;

        if (index > 0) {
          if (index < max) {
            this.currentIndex = index;
          } else if (index >= max && this.currentIndex !== max) {
            this.currentIndex = this.length - this.params.visibleSlides;
          } else {
            this.currentIndex = 0;
          }
        } else {
          if (this.currentIndex === 0) {
            this.currentIndex = this.length - this.params.visibleSlides;
          } else {
            this.currentIndex = 0;
          }
        }
      } else {
        if (index >= 0) {
          this.currentIndex = index % this.length;
        } else {
          this.currentIndex = this.length - 1;
        }
      }

      this.setNeighboursClasses();

      if (this.params.type === 'slide' && translate) {
        this.translate(transition);
      }
    } /////////////
    // SETTERS //
    /////////////

  }, {
    key: "setActiveClasses",
    value: function setActiveClasses() {
      var _this2 = this;

      var actives = _toConsumableArray(this.container.querySelectorAll('.is-active'));

      var currents = _toConsumableArray(this.container.querySelectorAll("[data-index=\"".concat(this.currentIndex, "\"]")));

      actives.forEach(function (current) {
        current.classList.remove('is-active');
      });
      currents.forEach(function (current) {
        current.classList.add('is-active');
        current.classList.remove('is-prev');
        current.classList.remove('is-next');
      });

      if (this.current.dataset.title && this.legend) {
        this.legend.innerHTML = this.current.dataset.title;
      }

      if (this.params.autoHeigth) {
        setTimeout(function () {
          var current = _this2.slider.querySelector("[data-index=\"".concat(_this2.currentIndex, "\"]"));

          var height = current.offsetHeight;
          _this2.slider.style.height = _this2.toPx(height);
        }, 0);
      }
    }
  }, {
    key: "setNeighboursClasses",
    value: function setNeighboursClasses() {
      var _this3 = this;

      this.current = this.slides.filter(function (slide) {
        return parseInt(slide.dataset.index, 10) === _this3.currentIndex;
      })[0];
      var prev = this.current.previousElementSibling;
      var next = this.current.nextElementSibling;

      while (prev) {
        prev.classList.add('is-prev');
        prev.classList.remove('is-next');
        prev = prev.previousElementSibling;
      }

      while (next) {
        next.classList.add('is-next');
        next.classList.remove('is-prev');
        next = next.nextElementSibling;
      }

      if (this.params.infinite && this.currentIndex >= this.length - 1) {
        var first = this.slides.filter(function (slide) {
          return parseInt(slide.dataset.index, 10) === 0;
        })[0];
        first.classList.remove('is-prev');
        first.classList.remove('is-next');
      }

      if (this.params.infinite && this.currentIndex < 0) {
        var last = this.slides.filter(function (slide) {
          return parseInt(slide.dataset.index, 10) === _this3.length - 1;
        })[0];
        last.classList.remove('is-prev');
        last.classList.remove('is-next');
      }

      this.setActiveClasses();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions() {
      var _this4 = this;

      this.visibleSlides = this.getVisibleSlides(this.params.visibleSlides);
      var containerWidth = this.carousel.offsetWidth;
      this.itemWidth = this.carousel.offsetWidth / this.visibleSlides;
      var sliderWidth = this.params.infinite ? this.itemWidth * (this.length + 2) : this.itemWidth * this.length;
      this.setTransition(0);
      this.slider.style.width = this.toPx(sliderWidth);
      this.slides.forEach(function (el, index) {
        el.style.width = _this4.toPx(_this4.itemWidth);
      });
      this.carousel.classList.add('is-init');
    } /////////////
    // GETTERS //
    /////////////

  }, {
    key: "getVisibleSlides",
    value: function getVisibleSlides(defaultValue) {
      if (this.params.breakpoints && this.params.breakpoints.filter(function (o) {
        return o.breakpoint > window.innerWidth;
      }).length) {
        return this.params.breakpoints.find(function (o) {
          return o.breakpoint > window.innerWidth;
        }).slides;
      }

      return defaultValue;
    } //////////////
    // BINDINGS //
    //////////////

  }, {
    key: "bindHover",
    value: function bindHover() {
      var _this5 = this;

      this.carousel.addEventListener('mouseenter', function () {
        clearInterval(_this5.interval);
      });
      this.carousel.addEventListener('mouseleave', function () {
        _this5.loop();
      });
    }
  }, {
    key: "bindResize",
    value: function bindResize() {
      var _this6 = this;

      if (this.params.type !== 'fade') {
        window.addEventListener('resize', function (event) {
          _this6.setDimensions();

          _this6.translate();
        });
      }
    }
  }, {
    key: "bindVisibilityChange",
    value: function bindVisibilityChange() {
      var _this7 = this;

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          clearInterval(_this7.interval);
        } else {
          _this7.loop();
        }
      });
    }
  }, {
    key: "bindControls",
    value: function bindControls() {
      var _this8 = this;

      if (this.length > 1) {
        this.container.addEventListener('click', function (event) {
          if (!_this8.animating) {
            if (event.srcElement.classList.contains('js-carousel-control')) {
              event.srcElement.classList.contains('prev') ? _this8.prev() : _this8.next();

              _this8.loop();
            }

            if (event.srcElement.classList.contains('carousel-item')) {
              var index = event.srcElement.dataset.index;
              index !== _this8.currentIndex ? _this8.goTo(index) : function () {};

              _this8.loop();
            }

            if (event.srcElement.classList.contains('carousel-dot')) {
              var _index = parseInt(event.srcElement.dataset.index, 10);

              _index !== _this8.currentIndex ? _this8.goTo(_index) : function () {};

              _this8.loop();
            }
          }
        });
      }
    }
  }, {
    key: "bindHammer",
    value: function bindHammer() {
      var _this9 = this;

      if (this.params.hammerEnabled && this.params.hammerBreakpoint > window.innerWidth) {
        this.hammer = new Hammer(this.carousel, {
          touchAction: 'pan-y'
        });
        this.hammer.on('panleft panright', function (event) {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || _this9.touching) {
            clearInterval(_this9.interval);

            _this9.setTransition(0);

            _this9.slider.style.transform = "translateX(".concat(_this9.toPx(_this9.posX + event.deltaX), ")");
            _this9.touching = true;
          }
        });
        this.hammer.on('panend', function (event) {
          var current = -Math.round(event.deltaX / (_this9.itemWidth / 2)) + _this9.currentIndex;

          _this9.setTransition();

          current >= 0 ? _this9.goTo(current) : _this9.goTo(_this9.length - 1);
          _this9.touching = false;

          _this9.loop();
        });
      }
    } ///////////////////////////////
    // TRANSFORM AND TRANSITION ///
    ///////////////////////////////

  }, {
    key: "setTransition",
    value: function setTransition() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.transition;
      var transition = value !== 0 ? "".concat(value / 1000, "s") : '0s';
      this.slider.style.transitionDuration = transition;
    }
  }, {
    key: "translate",
    value: function translate() {
      var _this10 = this;

      var transition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!transition) {
        this.setTransition(0);
      } else {
        this.animating = true;
      }

      this.posX = this.params.infinite ? -this.itemWidth * (this.currentIndex + 1) : -this.itemWidth * this.currentIndex;
      this.slider.style.transform = "translateX(".concat(this.toPx(this.posX), ")");
      this.slider.style['msTransform'] = "translateX(".concat(this.toPx(this.posX), ")");
      this.slider.style['webkitTransform'] = "translateX(".concat(this.toPx(this.posX), ")");
      setTimeout(function () {
        _this10.animating = false;

        if (_this10.currentIndex < 0) {
          _this10.prev(true, false);
        } else if (_this10.currentIndex === _this10.length) {
          _this10.next(true, false);
        }
      }, this.params.cssTransition);
    } //////////////
    // UTILS /////
    //////////////

  }, {
    key: "toPx",
    value: function toPx(value) {
      return "".concat(value, "px");
    }
  }, {
    key: "clear",
    value: function clear() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.slider;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      container.innerHTML = content;
    }
  }, {
    key: "loop",
    value: function loop() {
      var _this11 = this;

      if (this.params.auto) {
        this.interval;
        clearInterval(this.interval);
        this.interval = setInterval(function () {
          _this11.next();
        }, this.params.delay);
      }
    }
  }]);

  return Carousel;
}();

document.addEventListener('DOMContentLoaded', function () {
  var carousels = _toConsumableArray(document.getElementsByClassName('js-carousel'));

  if (carousels.length) {
    carousels.forEach(function (c) {
      new Carousel(c, null, {
        type: c.dataset.type || 'fade',
        auto: c.dataset.auto || false,
        infinite: c.dataset.infinite || false,
        steps: parseInt(c.dataset.steps, 10) || 1,
        visibleSlides: parseInt(c.dataset.slides, 10) || 1,
        autoDots: c.dataset.autoDots || false
      });
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Cover =
/*#__PURE__*/
function () {
  function Cover(cover) {
    _classCallCheck(this, Cover);

    this.cover = cover;
    this.container = cover.parentElement;
    this.ratio;
    this.load();
  }

  _createClass(Cover, [{
    key: "load",
    value: function load() {
      var _this = this;

      var src = this.cover.dataset.src;
      var img = new Image();
      img.addEventListener('load', function () {
        _this.cover.src = src;

        _this.listen();
      });
      img.src = src;
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this2 = this;

      this.ratio = this.cover.width / this.cover.height;
      setTimeout(function () {
        _this2.resize();
      }, 0);
      this.cover.classList.add('is-loaded');
      window.addEventListener('resize', function () {
        _this2.resize();
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      var ratio = this.container.clientWidth / this.container.clientHeight;

      if (ratio >= this.ratio) {
        this.cover.style.height = 'auto';
        this.cover.style.width = '100%';
      } else {
        this.cover.style.width = 'auto';
        this.cover.style.height = '100%';
      }
    }
  }]);

  return Cover;
}();

document.addEventListener('DOMContentLoaded', function () {
  var covers = _toConsumableArray(document.getElementsByClassName('js-cover-image'));

  if (covers.length) {
    covers.forEach(function (cover) {
      return new Cover(cover.querySelector('img'));
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Embed =
/*#__PURE__*/
function () {
  function Embed(container) {
    _classCallCheck(this, Embed);

    this.container = container;
    this.src = container.dataset.src;
    this.embed = container.querySelector('iframe');
    this.listen();
  }

  _createClass(Embed, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.container.addEventListener('click', function () {
        if (!_this.container.classList.contains('is-playing')) {
          _this.container.classList.add('is-playing');

          _this.embed.src = _this.src;
        }
      });
    }
  }]);

  return Embed;
}();

document.addEventListener('DOMContentLoaded', function () {
  var embeds = _toConsumableArray(document.getElementsByClassName('js-embed'));

  if (embeds.length) {
    embeds.forEach(function (embed) {
      return new Embed(embed);
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InputFile =
/*#__PURE__*/
function () {
  function InputFile(inputFile) {
    _classCallCheck(this, InputFile);

    this.inputFile = inputFile;
    this.value = this.inputFile.files;
    this.label = this.inputFile.nextElementSibling.querySelector('.js-filename');
    this.defaultLabel = this.label.innerHTML; // this.inputFile.classList.add('is-empty');

    this.listen();
  }

  _createClass(InputFile, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.inputFile.addEventListener('change', function (event) {
        _this.value = _this.inputFile.files;

        if (!_this.value.length) {
          _this.label.innerHTML = _this.defaultLabel;

          _this.inputFile.classList.remove('is-filled');
        } else {
          _this.label.innerHTML = _this.value[0].name;

          _this.inputFile.classList.add('is-filled');
        }
      });
    }
  }]);

  return InputFile;
}();

document.addEventListener('DOMContentLoaded', function () {
  var inputsFile = _toConsumableArray(document.getElementsByClassName('js-form-file'));

  if (inputsFile.length) {
    inputsFile.forEach(function (inputFile) {
      return new InputFile(inputFile);
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Dropdown =
/*#__PURE__*/
function () {
  function Dropdown(container) {
    var _this = this;

    _classCallCheck(this, Dropdown);

    this.container = container;
    this.wrapper = this.container.querySelector('.form-wrapper');
    this.list = this.container.querySelector('ul');
    this.button = this.container.querySelector('button');
    this.select = this.container.querySelector('select');
    this.values = [];

    _toConsumableArray(this.select.querySelectorAll('option')).forEach(function (element) {
      if (!element.disabled) {
        _this.values.push({
          element: element,
          value: element.value,
          label: element.textContent
        });
      }
    });

    this.init();
  }

  _createClass(Dropdown, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.generateList();
      this.select.addEventListener('focus', function (event) {
        _this2.button.click();
      });
    }
  }, {
    key: "generateList",
    value: function generateList() {
      var _this3 = this;

      var button = document.createElement('BUTTON');
      var list = document.createElement('UL');
      button.setAttribute('type', 'button');
      button.addEventListener('click', function (event) {
        return _this3.toggle();
      });
      this.button = button;
      this.list = list;
      this.wrapper.appendChild(button);
      this.wrapper.appendChild(list);
      this.list.addEventListener('keydown', function (event) {
        event.preventDefault();
        var previous = event.target.previousSibling;
        var next = event.target.nextSibling;

        if (event.keyCode === 38 && previous) {
          event.target.previousSibling.focus();
        }

        if (event.keyCode === 40 && next || event.keyCode === 9 && next) {
          event.target.nextSibling.focus();
        }

        if (event.keyCode === 13) {
          event.target.click();
        }

        if (event.keyCode === 27) {
          _this3.toggle();
        }
      });
      this.values.forEach(function (val) {
        var item = document.createElement('LI');
        item.dataset.value = val.value;
        item.textContent = val.label;
        item.tabIndex = 0;

        _this3.bindClick(item);

        _this3.list.appendChild(item);
      });
    }
  }, {
    key: "bindClick",
    value: function bindClick(element) {
      var _this4 = this;

      element.addEventListener('click', function (event) {
        _this4.select.value = event.srcElement.dataset.value;

        var active = _this4.list.querySelector('.is-active');

        if (active) {
          active.classList.remove('is-active');
        }

        element.classList.add('is-active');

        _this4.toggle();
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var _this5 = this;

      var isOpen = this.container.classList.contains('is-open');

      var inputs = _toConsumableArray(document.getElementsByClassName('js-select'));

      inputs.forEach(function (d) {
        d.classList.remove('is-open');
      });

      if (!isOpen) {
        setTimeout(function () {
          _this5.container.classList.toggle('is-open');

          _this5.list.firstChild.focus();
        }, 0);
      }
    }
  }]);

  return Dropdown;
}();

document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementsByClassName('js-select')) {
    var inputs = _toConsumableArray(document.getElementsByClassName('js-select'));

    inputs.forEach(function (d) {
      new Dropdown(d);
    });
    document.addEventListener('click', function () {
      inputs.forEach(function (d) {
        d.classList.remove('is-open');
      });
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Modal =
/*#__PURE__*/
function () {
  function Modal(modal, togglers) {
    _classCallCheck(this, Modal);

    this.modal = modal;
    this.container = this.modal.children[0];
    this.togglers = togglers;
    this.closers = _toConsumableArray(this.modal.getElementsByClassName('js-close'));
    this.modalDelay = this.modal ? this.getTransition(this.modal) * 1000 : 1000;
    this.containerDelay = this.container ? this.getTransition(this.container) * 1000 : 0;
    this.listen();
  }

  _createClass(Modal, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.togglers.forEach(function (toggler) {
        toggler.addEventListener('click', function () {
          _this.open();
        });
      });
      this.closers.forEach(function (closer) {
        closer.addEventListener('click', function () {
          _this.close();
        });
      });
      this.modal.addEventListener('click', function (event) {
        _this.close();
      });
      this.container.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      this.modal.style.display = '-webkit-box';
      this.modal.style.display = '-moz-box';
      this.modal.style.display = '-ms-flexbox';
      this.modal.style.display = '-webkit-flex';
      this.modal.style.display = 'flex';
      document.body.classList.add('has-body-fixed');
      setTimeout(function () {
        _this2.modal.classList.add('is-open');
      }, 10);
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;

      this.modal.classList.remove('is-open');
      document.body.classList.remove('has-body-fixed');
      setTimeout(function () {
        _this3.modal.style.display = 'none';
      }, this.modalDelay + this.containerDelay);
    }
  }, {
    key: "getTransition",
    value: function getTransition(element) {
      var transition = getComputedStyle(element).transitionDuration.replace('s', '');
      return parseFloat(transition) * 1000;
    }
  }]);

  return Modal;
}();

document.addEventListener('DOMContentLoaded', function () {
  var modals = _toConsumableArray(document.getElementsByClassName('js-modal'));

  var togglers = _toConsumableArray(document.getElementsByClassName('js-open-modal'));

  if (modals.length) {
    modals.forEach(function (modal) {
      return new Modal(modal, togglers.filter(function (toggler) {
        return toggler.dataset.target === modal.id;
      }));
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Gallery =
/*#__PURE__*/
function () {
  function Gallery(gallery) {
    _classCallCheck(this, Gallery);

    this.gallery = gallery;
    this.galleryViewer = gallery.querySelector('.js-gallery-viewer');
    this.gallerySelector = gallery.querySelector('.js-gallery-selector');
    this.gallerySelectorContainer = gallery.querySelector('.js-gallery-selector-container');
    this.initSelectors();
    this.initControls();
    this.bindResize();
    this.bindMouseMove();
    this.bindKeydown();
    this.toggleControls();
  }

  _createClass(Gallery, [{
    key: "initSelectors",
    value: function initSelectors() {
      var _this = this;

      var selectors = _toConsumableArray(this.gallery.querySelectorAll('.js-gallery-selector ul li'));

      this.selectors = selectors.map(function (selector, index) {
        _this.bindClick(selector, function () {
          return _this.goTo(index);
        });

        return {
          element: selector,
          src: selector.dataset.src
        };
      });
      this.initGallery();
    }
  }, {
    key: "initControls",
    value: function initControls() {
      var _this2 = this;

      var _loop = function _loop(index) {
        _this2.setControl(_this2.gallery.dataset.controlsIcon, function (button) {
          _this2.bindClick(button, function () {
            _this2.toggleControls();

            if (index === 0) {
              _this2.prev();
            } else {
              _this2.next();
            }
          });
        });
      };

      for (var index = 0; index < 2; index += 1) {
        _loop(index);
      }

      this.setControl(this.gallery.dataset.fsOpenIcon, function (button) {
        _this2.fullscreenIcon = button.firstChild;

        _this2.bindClick(button, function () {
          return _this2.toggleFullScreen();
        });
      });
    }
  }, {
    key: "initGallery",
    value: function initGallery() {
      this.selectors[0].element.click();
    }
  }, {
    key: "bindClick",
    value: function bindClick(element) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      element.addEventListener('click', function () {
        callback();
      });
    }
  }, {
    key: "bindResize",
    value: function bindResize() {
      var _this3 = this;

      var defaultImageSize = this.gallery.dataset.sizeSelectors;
      var defaultCount = 3;

      var resize = function resize() {
        var offsetWidthGallerySelector = _this3.gallerySelector.offsetWidth;
        _this3.resizeCount = Math.floor(offsetWidthGallerySelector / defaultImageSize);

        if (_this3.resizeCount < defaultCount) {
          _this3.resizeCount = defaultCount;
        }

        _this3.resizeSizeImage = offsetWidthGallerySelector / _this3.resizeCount;

        _this3.selectors.map(function (selector, index) {
          selector.element.style.minWidth = "".concat(_this3.resizeSizeImage, "px");
        });
      };

      window.addEventListener('resize', resize);
      setTimeout(function () {
        return resize();
      }, 100);
      window.addEventListener('resize', function () {
        return _this3.moveContainerNext();
      });
    }
  }, {
    key: "bindMouseMove",
    value: function bindMouseMove() {
      var _this4 = this;

      this.galleryViewer.addEventListener('mousemove', function () {
        _this4.toggleControls();
      });
      this.galleryViewer.addEventListener('mouseout', function () {
        _this4.toggleControls(0);
      });
    }
  }, {
    key: "bindKeydown",
    value: function bindKeydown() {
      var _this5 = this;

      window.addEventListener('keydown', function (e) {
        if (_this5.isFullScreen()) {
          if (e.keyCode === 39) {
            _this5.next();
          } else if (e.keyCode === 37) {
            _this5.prev();
          } else if (e.keyCode === 27) {
            _this5.toggleFullScreen();
          }
        }
      });
    }
  }, {
    key: "prev",
    value: function prev() {
      var index = this.currentIndex > 0 ? (this.currentIndex - 1) % this.selectors.length : this.selectors.length - 1;
      this.goTo(index);
      this.moveContainerPrev();
    }
  }, {
    key: "next",
    value: function next() {
      var index = (this.currentIndex + 1) % this.selectors.length;
      this.goTo(index);
      this.moveContainerNext();
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      var _this6 = this;

      var img = new Image();
      var src = this.selectors[index].src;
      this.currentIndex = index;
      this.galleryViewer.classList.add('is-loading');

      img.onload = function () {
        _this6.galleryViewer.style.backgroundImage = "url(".concat(src, ")");

        _this6.galleryViewer.classList.remove('is-loading');
      };

      img.onerror = function () {
        _this6.gallery.classList.remove('is-loading');
      };

      img.src = src;
      this.setActive();
    }
  }, {
    key: "setActive",
    value: function setActive() {
      this.selectors.forEach(function (selector) {
        return selector.element.classList.remove('is-active');
      });
      this.selectors[this.currentIndex].element.classList.add('is-active');
    }
  }, {
    key: "moveContainerNext",
    value: function moveContainerNext() {
      var slideIn = "translateX(".concat(this.resizeSizeImage * (this.currentIndex - this.resizeCount + 1) * -1, "px)");

      if (this.currentIndex >= this.resizeCount) {
        this.gallerySelectorContainer.style.transform = slideIn;
      }

      if (this.currentIndex === 0) {
        this.gallerySelectorContainer.style.transform = 'translateX(0px)';
      }
    }
  }, {
    key: "moveContainerPrev",
    value: function moveContainerPrev() {
      if (this.currentIndex + 1 >= this.resizeCount) {
        var slideIn = "translateX(".concat(this.resizeSizeImage * (this.currentIndex - this.resizeCount + 1) * -1, "px)");
        this.gallerySelectorContainer.style.transform = slideIn;
      }
    }
  }, {
    key: "setControl",
    value: function setControl() {
      var classList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var button = document.createElement('button');
      button.setAttribute('type', 'button');

      if (this.gallery.dataset.controlsClasses) {
        this.gallery.dataset.controlsClasses.split(' ').forEach(function (c) {
          return button.classList.add(c);
        });
      }

      if (classList) {
        button.innerHTML = "<span class=\"css-icon is-".concat(classList, "\"></span>");
      } else {
        button.innerHTML = '<span class="css-icon is-chevron"></span>';
      }

      this.galleryViewer.append(button);
      callback(button);
    }
  }, {
    key: "toggleControls",
    value: function toggleControls() {
      var _this7 = this;

      var timer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
      this.gallery.classList.add('has-controls');

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        _this7.gallery.classList.remove('has-controls');
      }, timer);
    }
  }, {
    key: "toggleFullScreen",
    value: function toggleFullScreen() {
      document.body.classList.toggle('has-body-fixed');
      this.gallery.classList.toggle('is-fullscreen');
      this.fullscreenIcon.classList.toggle("is-".concat(this.gallery.dataset.fsOpenIcon));
      this.fullscreenIcon.classList.toggle("is-".concat(this.gallery.dataset.fsCloseIcon));
    }
  }, {
    key: "isFullScreen",
    value: function isFullScreen() {
      return this.gallery.classList.contains('is-fullscreen');
    }
  }]);

  return Gallery;
}();

document.addEventListener('DOMContentLoaded', function () {
  var galleries = _toConsumableArray(document.getElementsByClassName('js-gallery'));

  if (galleries.length) {
    galleries.forEach(function (gallery) {
      return new Gallery(gallery);
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Notif =
/*#__PURE__*/
function () {
  function Notif(container) {
    _classCallCheck(this, Notif);

    this.container = container;
    this.notifications = [];
    this.listen();
  }

  _createClass(Notif, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.container.addEventListener('click', function (event) {
        _this.remove(event.srcElement);
      });
    }
  }, {
    key: "remove",
    value: function remove(element) {
      var _this2 = this;

      element.classList.remove('is-active');
      setTimeout(function () {
        _this2.container.removeChild(element);
      }, 500);
    }
  }, {
    key: "createElement",
    value: function createElement(tag, classes, content) {
      var t = document.createElement(tag);
      var c = document.createTextNode(content);
      t.appendChild(c);

      if (classes) {
        t.classList.add(classes);
      }

      return t;
    }
  }, {
    key: "getNode",
    value: function getNode(theme, header, comment) {
      var node = document.createElement('div');
      node.classList.add('notification', "is-".concat(theme));

      if (header) {
        node.appendChild(this.createElement('p', 'notification-title', header));
      }

      if (comment) {
        node.appendChild(this.createElement('p', null, comment));
      }

      return node;
    }
  }, {
    key: "setNotification",
    value: function setNotification(theme, header, comment) {
      var _this3 = this;

      var auto = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var node = this.getNode(theme, header, comment);
      this.container.appendChild(node);
      setTimeout(function () {
        node.classList.add('is-active');
      }, 100);

      if (auto) {
        setTimeout(function () {
          _this3.remove(node);
        }, 5000);
      }
    }
  }]);

  return Notif;
}();

document.addEventListener('DOMContentLoaded', function () {
  var notification = document.getElementById('js-notif');

  var callers = _toConsumableArray(document.getElementsByClassName('js-call-notif'));

  if (notification) {
    var component = new Notif(notification);

    if (callers) {
      callers.forEach(function (caller) {
        caller.addEventListener('click', function () {
          component.setNotification(caller.dataset.theme, caller.dataset.title, caller.dataset.comment, caller.dataset.auto);
        });
      });
    }
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ScrollTo =
/*#__PURE__*/
function () {
  function ScrollTo(source) {
    _classCallCheck(this, ScrollTo);

    this.source = source;
    this.target = document.getElementById(this.source.dataset.target) || null;
    this.container = document.getElementById(this.source.dataset.container);
    this.listen();
  }

  _createClass(ScrollTo, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      var listener = this.container ? this.container : window;

      if (this.target) {
        this.source.addEventListener('click', function (event) {
          event.preventDefault();
          var top = _this.container ? _this.target.offsetTop : listener.scrollY + _this.target.getBoundingClientRect().top;
          listener.scroll({
            top: top,
            behavior: 'smooth'
          });
        });
      }
    }
  }]);

  return ScrollTo;
}();

document.addEventListener('DOMContentLoaded', function () {
  var sources = _toConsumableArray(document.getElementsByClassName('js-scroll-to'));

  if (sources.length) {
    sources.forEach(function (s) {
      return new ScrollTo(s);
    });
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tabs =
/*#__PURE__*/
function () {
  function Tabs(container, params) {
    _classCallCheck(this, Tabs);

    this.container = container;
    this.tabsToggles = _toConsumableArray(container.getElementsByClassName('js-tab-toggle'));
    this.tabsContent = _toConsumableArray(container.getElementsByClassName('js-tab-content'));
    this.contentContainer = _toConsumableArray(container.getElementsByClassName('js-tab-container'))[0];
    this.cursor = container.getElementsByClassName('tab-cursor')[0];
    this.delay = this.tabsContent.length ? this.getTransition(this.tabsContent[0]) : 1000;
    this.delay = params.transition ? 0 : this.delay;
    this.init();
  }

  _createClass(Tabs, [{
    key: "init",
    value: function init() {
      this.listen();

      if (this.activeTab) {
        this.activeTab.click();
      } else {
        this.tabsToggles[0].click();
      }
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      this.tabsToggles.forEach(function (item) {
        _this.activeTab = item.classList.contains('is-active') ? item : _this.activeTab;
        item.addEventListener('click', function () {
          var target = item.dataset.target;

          var activeContent = _this.container.querySelector("[data-content=".concat(target, "]"));

          if (!activeContent.classList.contains('is-active')) {
            _this.nextContent = activeContent;

            _this.setPositions();

            _this.unsetClasses();

            _this.activeTab = item;
            _this.activeContent = activeContent;

            _this.setClasses();
          }
        });
      });
      window.addEventListener('resize', function () {
        return _this.resize();
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      this.contentContainer.style.height = "".concat(this.activeContent.offsetHeight, "px");
    }
  }, {
    key: "unsetClasses",
    value: function unsetClasses() {
      if (this.activeTab) {
        this.activeTab.classList.remove('is-active');
      }

      if (this.activeContent) {
        var activeContent = this.activeContent;
        this.activeContent.classList.remove('is-active');
        setTimeout(function () {
          activeContent.style.display = 'none';
        }, this.delay);
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses() {
      var _this2 = this;

      this.activeTab.classList.add('is-active');
      setTimeout(function () {
        _this2.activeContent.style.display = 'block';
      }, this.delay);
      setTimeout(function () {
        _this2.resize();

        _this2.activeContent.classList.add('is-active');
      }, this.delay + 100);
      this.setUnderline();
    }
  }, {
    key: "setPositions",
    value: function setPositions() {
      var _this3 = this;

      var position = 'prev';
      this.tabsContent.forEach(function (content) {
        if (content === _this3.nextContent) {
          position = 'next';
          return;
        }

        content.classList.remove('is-next', 'is-prev');
        content.classList.add("is-".concat(position));
      });
    }
  }, {
    key: "setUnderline",
    value: function setUnderline() {
      this.cursor.style.width = "".concat(this.activeTab.offsetWidth, "px");
      this.cursor.style.left = "".concat(this.activeTab.offsetLeft, "px");
    }
  }, {
    key: "getTransition",
    value: function getTransition(element) {
      var transition = getComputedStyle(element).transitionDuration.replace('s', '');
      return parseInt(transition, 10) * 1000;
    }
  }]);

  return Tabs;
}();

document.addEventListener('DOMContentLoaded', function () {
  var tabs = _toConsumableArray(document.getElementsByClassName('js-tabs'));

  if (tabs.length) {
    tabs.forEach(function (tab) {
      return new Tabs(tab, {
        transition: tab.dataset.transition
      });
    });
  }
});